import { ISubItemSettings } from '@/interfaces/sub-item-settings';

export const calculateColumnWidths = (subItemSettings: ISubItemSettings) => {
  const columnWidth = {};

  const regularColumnsCount = subItemSettings.columns.length;
  const hasItemNameColumn = subItemSettings.itemNameColumn.checked;

  if (regularColumnsCount === 0 && !hasItemNameColumn) {
    return columnWidth;
  }

  // Calculate widths maintaining 2.25:1 ratio (item name : regular columns)
  const itemNameRatio = 2.25;
  const regularColumnRatio = 1;

  let totalRatioUnits = 0;
  if (hasItemNameColumn) {
    totalRatioUnits += itemNameRatio;
  }
  totalRatioUnits += regularColumnsCount * regularColumnRatio;

  const widthPerRatioUnit = 100 / totalRatioUnits;

  // Assign widths
  if (hasItemNameColumn) {
    columnWidth['item-name'] = itemNameRatio * widthPerRatioUnit;
  }

  for (const column of subItemSettings.columns) {
    columnWidth[column.id] = regularColumnRatio * widthPerRatioUnit;
  }

  return columnWidth;
};
